import FormItem from 'antd/es/form/FormItem';
import Input from 'antd/es/input';
import React, {useState} from 'react';

import {CustomSelect, ECustomSelectMode} from 'components/form/inputs/custom-select';
import {ECustomSelectValueTriggerEvent} from 'components/form/inputs/custom-select/custom-select';
import {CommonInfoFieldNames as FieldNames} from 'pages/ais/organization-structure/organization-structure-page.constants';
import {IOrgStructureTabProps} from 'pages/ais/organization-structure/organization-structure-page.types';

interface ICommonInfoTabProps extends IOrgStructureTabProps {
    isAffiliationSet: boolean;
}

export const CommonInfoTab = ({
    buttonsBar,
    isAffiliationSet,
    setValidationField,
    isDisabled,
}: ICommonInfoTabProps) => {
    const [isStatePartSet, setIsStatePartSet] = useState<boolean>(false);

    return (
        <>
            {buttonsBar?.()}
            <div
                className="tab-bordered"
            >
                <div
                    className="form-fields"
                >
                    <FormItem
                        name={FieldNames.affiliation}
                        label="Признак принадлежности к группе компаний, в которой существует возможность у
                    кого-либо из участников влиять на решения, принимаемые другими участниками группы"
                        rules={[{required: true}]}
                    >
                        <CustomSelect
                            onChange={value => {
                                setValidationField?.('isAffiliationSet', value === '1');
                            }}
                            handleTriggerEvent={(value, event) => {
                                if (event === ECustomSelectValueTriggerEvent.receivedDataFromFetcher) {
                                    setValidationField?.('isAffiliationSet', value?.lookupCode === '1');
                                }
                            }}
                            settings={{
                                url: 'valueLists/FLEX_VALUE?sublistCode=affiliation',
                                valuePath: 'lookupCode',
                                labelPath: 'meaning',
                                placeholder: 'Выберите значение',
                                isClearable: true,
                                showSearch: true,
                                isDisabled,
                            }}
                        />
                    </FormItem>
                    <FormItem
                        name={FieldNames.statePart}
                        label="Признак государственного участия в организации – участнике налогового мониторинга,
                            представляющей информацию"
                        rules={[{required: true}]}
                    >
                        <CustomSelect
                            onChange={value => {
                                setIsStatePartSet(value === '1');
                            }}
                            handleTriggerEvent={(value, event) => {
                                if (event === ECustomSelectValueTriggerEvent.receivedDataFromFetcher) {
                                    setIsStatePartSet(value?.lookupCode === '1');
                                }
                            }}
                            settings={{
                                url: 'valueLists/FLEX_VALUE?sublistCode=state_part',
                                valuePath: 'lookupCode',
                                labelPath: 'meaning',
                                placeholder: 'Выберите значение',
                                isClearable: true,
                                showSearch: true,
                                isDisabled,
                            }}
                        />
                    </FormItem>
                    <FormItem
                        name={FieldNames.position}
                        label="Признак принадлежности организации к головной организации группы компаний"
                        rules={[{required: isAffiliationSet}]}
                    >
                        <CustomSelect
                            settings={{
                                url: 'valueLists/FLEX_VALUE?sublistCode=position',
                                valuePath: 'lookupCode',
                                labelPath: 'meaning',
                                placeholder: 'Выберите значение',
                                isClearable: true,
                                showSearch: true,
                                isDisabled,
                            }}
                        />
                    </FormItem>
                    <FormItem
                        name={FieldNames.statePartType}
                        label="Способ государственного участия"
                        rules={[{required: isStatePartSet}]}
                    >
                        <CustomSelect
                            settings={{
                                url: 'valueLists/FLEX_VALUE?sublistCode=state_part_type',
                                valuePath: 'lookupCode',
                                labelPath: 'meaning',
                                placeholder: 'Выберите значение',
                                isClearable: true,
                                showSearch: true,
                                isDisabled,
                            }}
                        />
                    </FormItem>
                    <FormItem
                        name={FieldNames.companyGroupInterdependence}
                        label="Признак взаимозависимости к головной организации группы компаний (холдинга)
                         в соответствии с п.2 ст.105.1 НК РФ"
                        rules={[{required: isAffiliationSet}]}
                    >
                        <CustomSelect
                            settings={{
                                mode: ECustomSelectMode.multiple,
                                url: 'valueLists/FLEX_VALUE?sublistCode=cg_interdependence',
                                valuePath: 'lookupCode',
                                labelPath: 'meaning',
                                placeholder: 'Выберите значение',
                                isClearable: true,
                                showSearch: true,
                                isDisabled,
                            }}
                        />
                    </FormItem>
                    <FormItem
                        name={FieldNames.statePartShare}
                        className="pt-22"
                        label="Доля государственного участия, в процентах"
                        rules={[
                            {required: isStatePartSet},
                            {
                                validator: (_, value) => (
                                    Number(value) < 100
                                        ? Promise.resolve()
                                        : Promise.reject(new Error('Значение должно быть меньше 100'))
                                )
                            }
                        ]}
                    >
                        <Input
                            className="w-100"
                            type="number"
                            suffix="%"
                            placeholder="Введите значение (в процентах)"
                            disabled={isDisabled}
                        />
                    </FormItem>
                </div>
            </div>
        </>
    );
};
